import { render, staticRenderFns } from "./SyncCourseTeachers.vue?vue&type=template&id=597011b8"
import script from "./SyncCourseTeachers.vue?vue&type=script&lang=js"
export * from "./SyncCourseTeachers.vue?vue&type=script&lang=js"
import style0 from "./SyncCourseTeachers.vue?vue&type=style&index=0&id=597011b8&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports